<template>
    <div class="position-box trading" :class="{theme:theme}">
        <div class="head">
            <img class="back" src="@/assets/icon_back.png" @click="goBack" alt="">
            <div class="tab-box">
              <div class="tab tab1" :class="{active: lxIdx == 1}" @click="change(1,$t('bbjy.sj'))">{{$t('bbjy.sj')}}</div>
              <div class="tab tab2" :class="{active: lxIdx == 0}" @click="change(0,$t('langNew4.gd'))">{{$t('langNew4.gd')}}</div>
            </div>
        </div>
        <div class="cotainer">
          <div class="item-box1">
            <div><span class="title">{{currency | rewriteName}}/USDT</span></div>
            <ul class="ul-box">
              <li class="li">
                <div class="money">{{newprice}}</div>
                <div class="text" v-show="currency_way == 2">{{$t('bbjy.mc')}}</div>
                <div class="text" v-show="currency_way == 1">{{$t('bbjy.mr')}}</div>
              </li>
              <li class="li li2" :class="{active: currency_way == 2}" @click="buyChange(2)">
                <div class="t1">{{$t('bbjy.mc')}}</div>
              </li>
              <li class="li li2" :class="{active: currency_way == 1}" @click="buyChange(1)">
                <div class="t1">{{$t('bbjy.mr')}}</div>
              </li>
            </ul>
          </div>
          <ul class="num-wrap num-wrap2">
              <li class="num-li">
                <div class="num-lt">
                  <div class="t1">{{$t('hyjy.ss')}}</div>
                </div>
                <div class="num-rt">
                  <img class="icon" src="@/assets/new/jian2-light.png" @click="num(-1)" alt="">
                  <input class="input" v-model="number" type="number" @keyup="keyMoney" autocomplete="off" onkeyup="this.value=this.value.replace(/\D|^0/g,'')" onafterpaste="this.value=this.value.replace(/\D|^0/g,'')">
                  <img class="icon" src="@/assets/new/jia2-light.png" @click="num(1)" alt="">
                </div>
              </li>
              <li class="num-li" v-show="lxIdx == 0 && newprice">
                <div class="num-lt">
                  <div class="t1">{{$t('langNew4.gdj')}}</div>
                  <div class="t2" v-if="currency_way == 1"><span v-if="gdBuyIdx == 0"><={{(parseFloat(newprice)).toFixed(4)}}</span><span v-if="gdBuyIdx == 1">>={{newprice}}</span></div>
                  <div class="t2" v-else><span v-if="gdSellIdx == 0">>={{(parseFloat(newprice)).toFixed(4)}}</span><span v-if="gdSellIdx == 1"><={{newprice}}</span></div>
                </div>
                <div class="num-rt">
                  <img class="icon" src="@/assets/new/jian2-light.png" @click="numGd(-1)" alt="">
                  <input class="input" v-model="gdPrice" type="text" @keyup="keyMoneyGd()" autocomplete="off">
                  <img class="icon" src="@/assets/new/jia2-light.png" @click="numGd(1)" alt="">
                </div>
              </li>
            </ul>
            <div class="line"></div>
          <div class="gg-wrap">
            <div class="gg-box">
              <div class="text">{{$t('hyjy.gg')}}</div>
              <div class="select" @click="alertGg">
                <div class="gg">{{ggNum}}X</div>
                <img class="arrow" src="@/assets/new/theme/jinrujiantouxiao-white.png" alt="">
              </div>
            </div>
          <ul class="num-wrap">
              <li class="num-li">
                <div>{{$t('zyzs.title')}}</div>
                <img class="img2" v-if="!isZy" @click="zyChange" src="@/assets/new/close-zyzs.png" alt="">
                <img class="img2" v-else @click="zyChange" src="@/assets/new/open-zyzs.png" alt="">
              </li>
              <li class="num-li">
                <div class="num-lt">
                  <div class="t1">{{$t('hyjy.zy')}}</div>
                  <div class="t2">>={{newprice}}</div>
                </div>
                <div class="num-rt num-rt2">
                  <div class="num-box">
                    <img class="icon" src="@/assets/new/jian2-light.png" @click="numZy(-1)" alt="">
                    <input class="input" v-model="take_profit" type="text" @keyup="keyMoneyZy" autocomplete="off">
                    <img class="icon" src="@/assets/new/jia2-light.png" @click="numZy(1)" alt="">
                  </div>
                </div>
              </li>
              <li class="num-li">
                <div class="num-lt">
                  <div class="t1">{{$t('hyjy.zs')}}</div>
                  <div class="t2"><={{newprice}}</div>
                </div>
                <div class="num-rt num-rt2">
                  <div class="num-box">
                    <img class="icon" src="@/assets/new/jian2-light.png" @click="numZs(-1)" alt="">
                    <input class="input" v-model="stop_loss" type="text" @keyup="keyMoneyZs" autocomplete="off">
                    <img class="icon" src="@/assets/new/jia2-light.png" @click="numZs(1)" alt="">
                  </div>
                </div>
              </li>
          </ul>
          </div>
        </div>
        <div class="btn-box">
          <div class="t1">{{$t('jghy.sxf')}}<span class="money">{{deal_rate}}</span></div>
          <div class="t1 t2">{{$t('jghy.kyye2')}} <span class="money">USDT {{useBalance}}</span></div>
          <div class="btn-sell btn-bg" @click="sure(2)" v-if="currency_way == 2">{{$t('bbjy.mc')}}</div>
          <div class="btn-sell btn-bg" @click="sure(1)" v-else>{{$t('bbjy.mr')}}</div>
        </div>
        <div class="mask" v-show="isMask"></div>
        <div class="alert-select-box" v-show="isMask">
          <div class="title">
            <div class="title-head2">
              <img class="icon" src="@/assets/new/success.png" alt="">
              <div class="text">{{$t('langNew4.kccg')}}</div>
            </div>
            <img class="close close2" src="@/assets/new/close.png" @click="close" alt="">
          </div>
          <div class="item">{{currency | rewriteName}} <span class="bei">{{number}}{{$t('langNew4.shou')}}</span></div>
          <div class="item">{{$t('jghy.jyfx')}} <span v-if="currency_way == 2">{{$t('bbjy.mc')}}</span><span v-else>{{$t('bbjy.mr')}}</span></div>
          <div class="btn btn-bg" @click="details">{{$t('bzhl.ckdd')}}</div>
        </div>
        <div class="mask" v-show="isLx"></div>
        <div class="alert-select-box2" v-show="isLx">
          <div class="title">
            {{$t('langNew4.lx')}}
            <img class="close" src="@/assets/new/close.png" @click="close" alt="">
          </div>
          <ul class="select-ul">
            <li class="select" @click="change(1,$t('bbjy.sj'))">
              <div class="select-left">
                <div class="coin">{{$t('bbjy.sj')}}</div>
              </div>
              <img class="arrow" src="@/assets/new/tick.png" v-show="lxIdx == 1" alt="">
            </li>
            <li class="select"  @click="change(2,$t('langNew4.gd'))">
              <div class="select-left">
                <div class="coin">{{$t('langNew4.gd')}}</div>
              </div>
              <img class="arrow" src="@/assets/new/tick.png" v-show="lxIdx == 0" alt="">
            </li>
          </ul>
        </div>
        <!-- 设置挂单 -->
        <div class="mask" v-show="isGdan"></div>
        <div class="alert-select-box2" v-show="isGdan">
          <div class="title">
            {{$t('langNew4.lx')}}
            <img class="close" src="@/assets/new/close.png" @click="close" alt="">
          </div>
          <ul class="select-ul">
            <li class="select" v-show="currency_way == 1" @click="changeGdBuy(0,'Buy Limit')">
              <div class="select-left">
                <div class="coin">Buy Limit</div>
              </div>
              <img class="arrow" src="@/assets/new/tick.png" v-show="gdBuyIdx == 0" alt="">
            </li>
            <li class="select" v-show="currency_way == 1" @click="changeGdBuy(1,'Buy Stop')">
              <div class="select-left">
                <div class="coin">Buy Stop</div>
              </div>
              <img class="arrow" src="@/assets/new/tick.png" v-show="gdBuyIdx == 1" alt="">
            </li>
            <li class="select" v-show="currency_way == 2" @click="changeGdSell(0,'Sell Limit')">
              <div class="select-left">
                <div class="coin">Sell Limit</div>
              </div>
              <img class="arrow" src="@/assets/new/tick.png" v-show="gdSellIdx == 0" alt="">
            </li>
            <li class="select" v-show="currency_way == 2" @click="changeGdSell(1,'Sell Stop')">
              <div class="select-left">
                <div class="coin">Sell Stop</div>
              </div>
              <img class="arrow" src="@/assets/new/tick.png" v-show="gdSellIdx == 1" alt="">
            </li>
          </ul>
        </div>
        <div class="mask" v-show="isShow"></div>
        <!-- 密码框 -->
        <div class="alert-pwd-box" v-show="isShow">
             <img class="close" src="@/assets/new/close.png" @click="close" alt="">
            <div class="alert-head">{{$t('usdttb.qsrjymm')}}</div>
            <ul class="pwd-box">
                <li class="pwd" v-for="(item,index) in inputList" :key="index"><input class="input pwd-input" v-model="item.val" type="password" maxlength="1" oninput = "value=value.replace(/[^\d]/g,'')" @keyup="nextFocus($event,index)" inputmode="numeric" autocomplete="off"></li>
            </ul>
        </div>
        <!-- 调整杠杆弹窗 -->
        <div class="mask" v-show="isGg"></div>
        <div class="alert-select-box2" v-show="isGg">
          <div class="title">
            {{$t('hyjy.gg')}}
            <img class="close" src="@/assets/new/close.png" @click="close" alt="">
          </div>
          <ul class="select-ul">
            <li class="select" v-for="(item,index) in ggArr" :key="index" @click="changeGg(item.leverage,item.margin_num,item.mg_id)">
              <div class="select-left">
                <div class="coin">{{item.leverage}}X</div>
              </div>
              <img class="arrow" src="@/assets/new/tick.png" v-show="ggIdx == index" alt="">
            </li>
          </ul>
        </div>
        <div class="alert-gg" v-show="isGg">
            <ul class="alert-gg-head">
                <li>{{$t('hyjy.tzgg')}}</li>
                <li class="cancle" @click="cancle">{{$t('hyjy.qx')}}</li>
            </ul>
            <div class="gg-box">
                <div class="btn" @click="jian">-</div>
                <div class="input-box">
                    <input class="input" type="number" min="1" v-model="ggNum" onkeyup="this.value=this.value.replace(/\D|^0/g,'')" onafterpaste="this.value=this.value.replace(/\D|^0/g,'')">
                    <div class="dw">x</div>
                </div>
                <div class="btn" @click="add">+</div>
            </div>
            <div class="progess-box">
                <ul class="progess-ul">
                    <li class="progess" :class="{active: progessIdx == '0'}" @click="progess('0')">
                        <div class="progess-tips">1x</div>
                        <div class="progess-text">1x</div>
                    </li>
                    <li class="progess" :class="{active: progessIdx == '1'}" @click="progess('1')">
                        <div class="progess-tips">20x</div>
                        <div class="progess-text">20x</div>
                    </li>
                    <li class="progess" :class="{active: progessIdx == '2'}" @click="progess('2')">
                        <div class="progess-tips">40x</div>
                        <div class="progess-text">40x</div>
                    </li>
                    <li class="progess" :class="{active: progessIdx == '3'}" @click="progess('3')">
                        <div class="progess-tips">60x</div>
                        <div class="progess-text">60x</div>
                    </li>
                    <li class="progess" :class="{active: progessIdx == '4'}" @click="progess('4')">
                        <div class="progess-tips">80x</div>
                        <div class="progess-text">80x</div>
                    </li>
                    <li class="progess" :class="{active: progessIdx == '5'}" @click="progess('5')">
                        <div class="progess-tips">100x</div>
                        <div class="progess-text t6">100x</div>
                    </li>
                </ul>
            </div>
            <button type="button" class="btn-sure btn-bg" @click="progessSure">{{$t('hyjy.qr')}}</button>
        </div>
        <loading v-show="isLoad"></loading>
    </div>
</template>

<script>
import loading from '@/components/loading.vue'
export default {
    name: 'trading',
    data () {
        return {
          theme: false,
          uid: '',
          token: '',
          isMask: false,
          isMask2: false,
          isShow: false,
          isLx: false,
          isGg: false,
          currency: '',
          symbol: '',
          currency_way: 2,
          newprice: '',
          newprice2: '',
          number: 1,
          inputList: [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}],
          time_type: '',
          main_type: '',
          main_type2: '',
          currency_type: '',
          currency_name: '',
          currency_name2: '',
          money: '',
          buy_add_money: '',
          benchmark_num: '',
          rate: '',
          lxText: this.$t('bbjy.sj'),
          lxIdx: 1,
          progessIdx: 0,
          ggNum: 1,
          moneyPwd: '',
          gdPrice: 0,
          stop_loss: 0,
          stop_loss_cur: '',
          take_profit: 0,
          take_profit_cur: '',
          klineTimer: null,
          klineTimer2: null,
          isZy: false,
          isZs: false,
          bail_id: '',
          isZyzs: false,
          isLoad: false,
          isGdan: false,
          gdBuyIdx: 0,
          gdSellIdx: 0,
          gdText: '',
          ggArr: [],
          ggIdx: 0,
          margin_num: '',//最大杠杆
          curMargin_num: '',
          status_type: 1,//1 正向 2 反向 3 交叉
          downTimer: null,
          item: {},
          backPrice: '',
          useBalance: "",
          deal_rate: 0,//手续费
          xianjia: '',
          count: 1
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.lang = localStorage.getItem('language') || 'en';
      this.currency_way = this.$route.query.type;
      if(this.$route.query.symbol){
        this.symbol = this.$route.query.symbol;
        this.currency = this.$route.query.symbol.split('/')[0];
      }
    },
    mounted() {
      let that = this;
      let params = {
          id: 1
      }
      this.$ajax.get('/web/getmarketList',{params}).then((res) => {
          let resData = res.data.data;
          if(res.data.code == 1000){
            setTimeout(()=>{
              this.$router.push('/index');
            },1000)
            return false
          }
          if(that.symbol == '' || that.symbol == null){
            that.currency = resData[0].currency;
            that.symbol = resData[0].symbol;
            that.initWebSocket();
            that.getAsset();
            that.getCurPrice();
        }else{
          that.initWebSocket();
          that.getAsset();
          that.getCurPrice();
        }
      }).catch(function(err){
          console.log(err)
      })
    },
    methods: {
      initWebSocket(){ //初始化weosocket
        const wsuri = this.socket_url;
        this.websock = new WebSocket(wsuri);
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onclose = this.websocketclose;
      },
      websocketonopen(){ //连接建立之后执行send方法发送数据
        this.klineTimer = setInterval(()=>{
          var msg = {"action": "kline",'currency':this.currency,"content": ''};
          this.websocketsend(JSON.stringify(msg));
        },3000)
      },
      websocketonerror(){//连接建立失败重连
        this.initWebSocket();
      },
      websocketonmessage(e){ //数据接收
          let currency = this.currency;
          if(JSON.parse(e.data).action == "marketprice"){
              let msg = JSON.parse(e.data).content;
              let daymarket = msg[currency.toUpperCase()] || msg[currency.toLowerCase()];
              this.newprice = daymarket.now_price;
              this.maxprice = daymarket.high;
              this.minprice = daymarket.low;
              this.dayvom = Number(daymarket.volume).toFixed(4);
              this.updown = daymarket.change;
              if(this.isZy){

              }else{
                this.take_profit = 0;
                this.stop_loss = 0;
              }
              let keyArr = [];
              for(var x in this.currencyList){
                  for(var y in this.leftData){
                    if(!msg[x]) return;
                    if(msg[x].currency_name == this.leftData[y].currency_name){
                        this.leftData[y]['new_price'] = msg[x].now_price;
                        this.leftData[y]['change'] = msg[x].change;
                        keyArr.push(this.leftData[y]);
                        break;
                    }
                  }
              }
              this.leftData = keyArr;
          }else if(JSON.parse(e.data).action == "kline"){
              this.klineData = '';
              let msg = JSON.parse(e.data).content;
              this.klineData = msg.kline;
          }
      },
      websocketsend(Data){//数据发送
          this.websock.send(Data);
      },
      websocketclose(e){  //关闭
          // console.log('断开连接',e);
      },
      getCurPrice(){
        let that = this;
        let params = {
            id: 1,
            symbol: that.symbol,
        }
        this.$ajax.get('/web/getmarketList',{params}).then((res) => {
            let resData = res.data.data;
            that.xianjia = resData[0].new_price;
            that.gdPrice = resData[0].new_price || 0;
            that.take_profit_cur = that.stop_loss_cur = resData[0].new_price;
        }).catch(function(err){
            console.log(err)
        })
      },
      getGdText(){
        if(this.currency_way == 1){
          this.gdText = "Buy Limit"
        }else{
          this.gdText = "Sell Limit"
        }
      },
      sure(id){
        let that = this;
            if(that.number == '' || that.number <= 0){
                this.$toast.center(this.$t('tipsNew.qsrss'));
                return false;
            }else if(that.number < 1 ){
                this.$toast.center(this.$t('tipsNew.zdss') + 1);
                return false;
            }
            var price = this.lxIdx == 0 ? this.gdPrice : this.newprice;
            let params = {
                multiple: that.ggNum,
                price: price,
                amount: that.number,
                price_type: that.lxIdx,
                mark: id,
                currency: that.currency,
                deal_type: 2,
                stop_profit : that.take_profit,
                stop_loss:  that.stop_loss
            }
            that.account = '';
            this.$ajax.post('/web/createOrder',params).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                  that.isMask = true;
                  that.getAsset();
                }else{
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
      },
      getAsset(){
        let that = this;
        let params = {
          type: 2,
          currency: that.currency,
          multiple: that.ggNum
        }
        this.$ajax.get('/web/getInfo',{params}).then((res) => {
            let resData = res.data.data;
            that.useBalance =  (Number(resData.wallet.usdt)).toFixed(4);
            that.deal_rate = resData.deal_rate + '%'
        }).catch(function(err){
            console.log(err)
        })
      },
      changeGg(num,maxnum,id){
        this.ggNum = num;
        this.margin_num = maxnum;
        this.curMargin_num = maxnum;
        this.mg_id = id;
        this.isMask = this.isGg = false;
      },
      zyChange(){
        this.isZy = !this.isZy;
        if(!this.isZy){
          this.take_profit = 0;
          this.stop_loss = 0;
        }else{
          this.take_profit = this.take_profit_cur;
          this.stop_loss = this.stop_loss_cur;
        }
      },
      gdSelect(){
        this.isGdan = true;
      },
      changeGdBuy(idx,text){
        this.gdBuyIdx = idx;
        this.gdText = text;
        this.gdPrice = parseFloat(this.newprice);
        this.isZy = this.isZs = false;
        this.isGdan = false;
      },
      changeGdSell(idx,text){
        this.gdSellIdx = idx;
        this.gdText = text;
        this.gdPrice = parseFloat(this.newprice);
        this.isZy = this.isZs = false;
        this.isGdan = false;
      },
      setZyzs(){
        this.$router.push('/setProfit?mainType=' + this.main_type + '&id=' + this.bail_id + '&bz=' + this.currency + '&currencyName=' + this.currency_name + '&buyAddMoney=' + this.buy_add_money + '&backPrice=' + this.backPrice)
      },
        alertGg(){
          this.isGg = true;
        },
        select(){
          this.isLx = true;
        },
        change(idx,text){
          this.lxText = text;
          this.lxIdx = idx;
          this.gdPrice = parseFloat(this.newprice);
          this.isZy = this.isZs = false;
          this.isLx = false;
          this.number = 1;
        },
        getGg(){
          let params = {
            uid: this.uid,
            currency_type: this.currency_type
          }
          var url = JSON.parse(localStorage.getItem('isMn')) ? this.HOSTMn + '/api/index/marginIndex' : '/api/index/marginIndex';
          this.$ajax.post(url,params).then((res) => {
            let resData = res.data.data;
            if(res.data.code == 200){
              this.ggArr = resData;
              this.ggNum = resData[0].leverage;
              this.margin_num = resData[0].margin_num;
              this.curMargin_num = resData[0].margin_num;
              this.mg_id = resData[0].mg_id;
            }
          }).catch(function(err){
              console.log(err)
          })
        },
       goBack(){
           this.$router.go(-1)
       },
       num(id){
         if(id < 0){
           if(this.number > 1){
             this.number --
           }
         }else{
           this.number ++
         }
       },
      numZy(id){
         if(id < 0){
          if(parseFloat(this.take_profit) > parseFloat(this.take_profit_cur)){
            this.take_profit = (parseFloat(this.take_profit) - 1).toFixed(4)
          }
         }else{
           this.take_profit = (parseFloat(this.take_profit) + 1).toFixed(4)
         }
       },
       numZs(id){
         if(id < 0){
           if(parseFloat(this.stop_loss) > 1){
            this.stop_loss = (parseFloat(this.stop_loss) - 1).toFixed(4)
           }
           if(this.stop_loss <= 0) this.stop_loss = 0;
         }else{
           if(this.stop_loss < this.stop_loss_cur){
             this.stop_loss = (parseFloat(this.stop_loss) + 1).toFixed(4)
           }
         }
       },
       numGd(id){
         if(id < 0){
           if(parseFloat(this.gdPrice) > 1){
            if(this.currency_way == 2){
              if(this.gdSellIdx == 0){
                if(this.gdPrice > (parseFloat(this.newprice))){
                  this.gdPrice = (parseFloat(this.gdPrice) - 1).toFixed(4)
                }else{
                  this.gdPrice = (parseFloat(this.newprice)).toFixed(4)
                }
              }else{
                if(this.gdPrice <= this.newprice){
                  this.gdPrice = (parseFloat(this.gdPrice) - 1).toFixed(4)
                }
              }
            }else{
              if(this.gdBuyIdx == 0){
                this.gdPrice = (parseFloat(this.gdPrice) - 1).toFixed(4)
              }else{
                if(parseFloat(this.gdPrice) >= this.newprice){
                  this.gdPrice = (parseFloat(this.gdPrice) - 1).toFixed(4)
                }else{
                  this.gdPrice = this.newprice;
                }
              }
            }
           }
         }else{
           if(this.currency_way == 2){
              if(this.gdSellIdx == 0){
                this.gdPrice = (parseFloat(this.gdPrice) + 1).toFixed(4)
              }else{
                if(parseFloat(this.gdPrice) >= this.newprice){
                  this.gdPrice = this.newprice;
                }else{
                  this.gdPrice = (parseFloat(this.gdPrice) + 1).toFixed(4)
                }
              }
            }else{
              if(this.gdBuyIdx == 0){
                if(parseFloat(this.gdPrice) >= (parseFloat(this.newprice))){
                  this.gdPrice = (parseFloat(this.newprice)).toFixed(4)
                }else{
                  this.gdPrice = (parseFloat(this.gdPrice) + 1).toFixed(4)
                }
              }else{
                this.gdPrice = (parseFloat(this.gdPrice) + 1).toFixed(4)
              }
            }
         }
       },
       buyChange(idx){
        this.currency_way = idx;
        this.gdBuyIdx = this.gdSellIdx = this.take_profit = this.stop_loss = 0;
        this.isZy = this.isZs = false;
        this.getGdText();
       },
       progess(idx){
          this.progessIdx = idx;
          if(idx == 0){
              this.ggNum = 1
          }else if(idx == 1){
              this.ggNum = 20
          }else if(idx == 2){
              this.ggNum = 40
          }else if(idx == 3){
              this.ggNum = 60
          }else if(idx == 4){
              this.ggNum = 80
          }else{
              this.ggNum = 100
          }
        },
       progessSure(){//杠杆确认
          if(this.ggNum <= 0){
            this.ggNum = 1
          }
          this.isGg = false;
          this.isMask = false;
        },
        jian(){
            if(this.ggNum > 1){
                this.ggNum --;
            }
        },
        add(){
            if(this.ggNum < 100){
                this.ggNum ++;
            }
        },
        details(){
          this.isMask = false;
          this.$router.push('/contractOrder')
        },
       close(){
        this.isMask = this.isMask2 = this.isShow = this.isLx = this.isZyzs = this.isGdan = this.isGg = false;
        this.number = 1;
        this.ggNum = 1;
       },
       cancle(){
         this.isMask = this.isMask2 = this.isGg = false
       },
      keyMoney(){
        this.number = this.number.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.number = this.number.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.number = this.number.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.number = this.number.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.number.indexOf(".") < 0 && this.number != "") { //首位是0的话去掉
            this.number = parseFloat(this.number);
        }
      },
      keyMoneyZy(){
        this.take_profit = this.take_profit.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.take_profit = this.take_profit.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.take_profit = this.take_profit.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.take_profit = this.take_profit.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.take_profit.indexOf(".") < 0 && this.take_profit != "") { //首位是0的话去掉
            this.take_profit = parseFloat(this.take_profit);
        }
      },
      keyMoneyZs(){
        this.stop_loss = this.stop_loss.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.stop_loss = this.stop_loss.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.stop_loss = this.stop_loss.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.stop_loss = this.stop_loss.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.stop_loss.indexOf(".") < 0 && this.stop_loss != "") { //首位是0的话去掉
            this.stop_loss = parseFloat(this.stop_loss);
        }
      },
      keyMoneyGd(){
        this.gdPrice = this.gdPrice.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.gdPrice = this.gdPrice.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.gdPrice = this.gdPrice.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.gdPrice = this.gdPrice.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.gdPrice.indexOf(".") < 0 && this.gdPrice != "") { //首位是0的话去掉
            this.gdPrice = parseFloat(this.gdPrice);
        }
      },
    },
    watch: {
        gdPrice:function(val){
          if(this.gdPrice){
            if(this.currency_way == 2){
              if(this.gdSellIdx == 0){
                if(this.gdPrice <= (parseFloat(this.newprice))){
                  this.gdPrice = (parseFloat(this.newprice)).toFixed(4)
                }
              }else{
                if(this.gdPrice >= this.newprice){
                  this.gdPrice = this.newprice
                }
              }
            }else{
              if(this.gdBuyIdx == 0){
                if(this.gdPrice >= (parseFloat(this.newprice))){
                  this.gdPrice = (parseFloat(this.newprice)).toFixed(4)
                }
              }else{
                if(this.gdPrice <= this.newprice){
                  this.gdPrice = this.newprice
                }
              }
            }
          }
        },
        number:function(val){
          if(this.number){
            this.margin_num = this.curMargin_num * this.number;
          }
        }
    },
    components:{
        loading
    },
    beforeDestroy(){
      clearInterval(this.klineTimer);
      this.klineTimer = null;
      clearInterval(this.klineTimer2);
      clearInterval(this.downTimer);
      this.downTimer = null;
      this.klineTimer2 = null;
    },
    destroyed() {
      clearInterval(this.klineTimer);
      this.klineTimer = null;
      clearInterval(this.klineTimer2);
      clearInterval(this.downTimer);
      this.downTimer = null;
      this.klineTimer2 = null;
    }
}
</script>
<style scoped>
  .position-box{
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    color: #cecece;
    font-size: .24rem;
    background: url('../assets/element-background.png') no-repeat center center;
    background-size: cover;
    overflow: hidden;
  }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        color: #fff;
        font-size: .45rem;
        line-height: 1.6rem;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .32rem;
        transform: translateY(-50%);
    }
    .head .tab-box{
      display: flex;
      justify-content: center;
      margin-top: .35rem;
    }
    .head .tab-box .tab{
      min-width: 2.76rem;
      height: 0.9rem;
      padding: 0 .2rem;
      color: #4458ed;
      line-height: .9rem;
      border: solid 0.01rem #4458ed;
      box-sizing: border-box;
    }
    .head .tab-box .tab.active{
      color: #fff!important;
      background: #4458ed!important;
    }
    .head .tab-box .tab1{
      border-radius: .1rem 0 0 .1rem;
    }
    .head .tab-box .tab2{
      border-radius: 0 .1rem .1rem 0;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 4.5rem;
        width: 100%;
        overflow-y: scroll;
    }
    .item-box1{
      padding: .4rem .42rem 0;
    }
    .item-box1 .title{
      color: #fff;
      font-size: .48rem;
    }
    .stop-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .4rem .5rem;
      border-bottom: 1px solid #f0f0f0;
    }
    .stop-box .text{
      flex: 1;
      color: #fff;
      font-size: .42rem;
    }
    .stop-box .fx{
      padding: 0 .3rem;
      color: #a9a9a9;
      font-size: .4rem;
    }
    .stop-box .arrow{
      width: .42rem;
    }
    .item-box1 .dan{
      position: relative;
      display: inline-block;
      padding: 0 .15rem 0 .3rem;
      color: #2d66cf;
      font-size: .48rem;
    }
    .item-box1 .dan::after{
      position: absolute;
      right: -.15rem;
      top: 50%;
      content: '';
      width: .28rem;
      height: .2rem;
      background: url(../assets/new/sanjiao.png) no-repeat center center;
      background-size: cover;
      transform: translateY(-50%);
    }
    .item-box1 .ul-box{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-flow: wrap;
      padding: .64rem 0 .6rem;
      border-bottom: 1px solid #313a47;
    }
    .item-box1 .ul-box .li{
      position: relative;
      flex: 1;
      margin-right: .4rem;
      color: #fff;
      font-size: .34rem;
      box-sizing: border-box;
    }
    .item-box1 .ul-box .li .money{
      color: #00c483;
      font-size: .64rem;
    }
    .item-box1 .ul-box .li .text{
      padding-top: .3rem;
      font-size: .42rem;
    }
    .item-box1 .ul-box .li:last-child{
      margin-right: 0;
    }
    .item-box1 .ul-box .li.active::after{
      position: absolute;
      right: -1px;
      bottom: 0;
      content: '';
      width: .68rem;
      height: .5rem;
      background: url(../assets/new/xuanzhong2.png) no-repeat center center;
      background-size: cover;
    }
    .item-box1 .ul-box .li2{
      width: 2.32rem;
	    height: 0.94rem;
      flex: inherit;
      font-size: .4rem;
      line-height: .94rem;
      border-radius: 0.1rem;
      border: 1px solid #4458ed;
      text-align: center;
    }
    .theme .item-box1 .ul-box .li.active::after{
      position: absolute;
      right: -1px;
      bottom: 0;
      content: '';
      width: .48rem;
      height: .36rem;
      background: url(../assets/new/theme/feixuanzhong.png) no-repeat center center;
      background-size: cover;
    }
    .item-box1 .ul-box .li .t2{
      padding-top: .28rem;
      font-size: .52rem;
    }
    .item-box1 .ul-box .li.active{
      color: #fff;
      border: 1px solid #2d66cf;
    }
    .num-wrap2{
      padding: 0 .4rem;
    }
    .num-wrap .num-li{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .45rem 0 .5rem;
      font-size: .4rem;
      border-bottom: 1px solid #313a47;
    }
    .num-wrap .num-li .img2{
      width: 1.25rem;
    }
    .num-wrap .num-li:last-child{
      border-bottom: none;
    }
    .num-wrap .num-li .num-lt .t1{
      color: #fff;
      font-size: .38rem;
    }
    .num-wrap .num-li .num-lt .t2{
      padding-top: .3rem;
      color: #a7a7a7;
      font-size: .4rem;
    }
    .num-wrap .num-li .num-rt{
      display: flex;
      align-items: center;
    }
    .num-wrap .num-li .input{
      width: 2.7rem;
      height: .82rem;
      margin: 0 .2rem;
      color: #fff;
      font-size: .42rem;
      border: 1px solid #e4e4e4;
      text-align: center;
    }
    .num-wrap .num-li .num-rt .icon{
      width: .36rem;
      height: .36rem;
    }
    .num-wrap .num-li .num-rt2{
      display: block;
      text-align: center;
    }
    .num-wrap .num-li .num-lt .img{
      width: 1.25rem;
      margin-top: .3rem;
    }
    .num-wrap .num-li .num-rt .text{
      padding-bottom: .36rem;
      color: #cdcdcd;
      font-size: .3rem;
    }
    .num-wrap .num-li .num-rt2 .num-box{
      display: flex;
      align-items: center;
    }
    .gg-wrap{
      padding: 0 .4rem;
    }
    .gg-wrap .gg-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .65rem 0 .85rem;
      color: #fff;
    }
    .gg-wrap .gg-box .text{
      font-size: .38rem;
    }
    .gg-wrap .gg-box .select{
      display: flex;
      align-items: center;
      font-size: .4rem;
    }
    .gg-wrap .gg-box .select .arrow{
      width: .42rem;
      padding-left: .15rem;
    }
    .btn-box{
      position: absolute;
      bottom: .5rem;
      width: 100%;
      padding: .4rem;
      box-sizing: border-box;
      text-align: center;
    }
    .btn-box .t1{
      color: #fff;
      font-size: .4rem;
    }
    .btn-box .t2{
      padding: .45rem 0 .5rem;
    }
    .btn-box .money{
      color: #fff;
    }
    .alert-select-box{
      position: absolute;
      bottom: 0;
      z-index: 1000;
      left: 0;
      right: 0;
      padding: 0 .62rem .84rem;
      border-radius: .4rem .4rem 0 0;
      background: #0f1a2a;
      box-sizing: border-box;
    }
    .alert-select-box .title{
      position: relative;
      margin-bottom: .2rem;
      padding: .74rem 0;
      text-align: center;
    }
    .alert-select-box .title .title-head{
      color: #1cb460;
      font-size: .46rem;
    }
    .alert-select-box .title .title-head .icon{
      width: 1.98rem;
      margin-bottom: .5rem;
    }
    .alert-select-box .close{
      position: absolute;
      right: 0;
      top: .55rem;
      width: .72rem;
    }
    .alert-select-box .item{
      color: #fff;
      font-size: .42rem;
      margin-bottom: .45rem;
      text-align: center;
    }
    .alert-select-box .title .title-head2{
      text-align: center;
    }
    .alert-select-box .title .title-head2 .icon{
      width: 1.98rem;
    }
    .alert-select-box .title .title-head2 .text{
      padding-top: .54rem;
      color: #1cb460;
      font-size: .56rem;
    }
    .alert-select-box .close2{
      top: .54rem;
      transform: translateY(0);
    }
    .alert-select-box .select{
      padding-bottom: .45rem;
    }
    .alert-select-box .select .t1{
      color: #646464;
      font-size: .38rem;
    }
    .alert-select-box .select .t2{
      color: #000;
      font-size: .38rem;
      text-align: center;
    }
    .alert-select-box .select .t2 .arrow{
      width: .42rem;
    }
    .alert-select-box .bei{
      display: inline-block;
      margin-left: .26rem;
      padding: .16rem .26rem;
      color: #2d66cf;
      font-size: .34rem;
      background: #dfeaff;
	    border-radius: 0.1rem;
    }
    .alert-select-box .btn{
      margin-top: .9rem;
    }
    .alert-select-box2{
      position: absolute;
      bottom: 0;
      z-index: 1000;
      width: 100%;
      padding: 0 .62rem .84rem;
      border-radius: .4rem .4rem 0 0;
      background: #0f1a2a;
      box-sizing: border-box;
    }
    .alert-select-box2 .title{
      position: relative;
      margin-bottom: .96rem;
      padding: .74rem 0;
      color: #000;
      font-size: .56rem;
      text-align: center;
    }
    .alert-select-box2 .close{
      position: absolute;
      right: 0;
      top: 50%;
      width: .72rem;
      transform: translateY(-50%);
    }
    .alert-select-box2 .select-ul{
      max-height: 300px;
      overflow-y: scroll;
    }
    .alert-select-box2 .select-ul .select{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: .64rem;
      padding: .42rem .56rem;
      border-radius: .2rem;
      background: #f3f5fa;
    }
    .alert-select-box2 .select-ul .select-left{
      display: flex;
      align-items: center;
    }
    .alert-select-box2 .select-ul .icon{
      width: .96rem;
    }
    .alert-select-box2 .select-ul .coin{
      padding-left: .48rem;
      color: #000;
      font-size: .48rem;
    }
    .alert-select-box2 .arrow{
      width: .58rem;
    }
     /* 杠杆弹窗 */
    .alert-gg{
        position: absolute;
        left: -1px;
        right: 0;
        bottom: 0;
        z-index: 1000;
        padding: .66rem .72rem .48rem .72rem;
        background: #0f1a2a;
        box-sizing: border-box;
    }
    .alert-gg .alert-gg-head{
        position: relative;
        color: #fff;
        font-size: .54rem;
        text-align: center;
    }
    .alert-gg .alert-gg-head .cancle{
        position: absolute;
        right: 0;
        top: 0;
        color: #898989;;
        font-size: .42rem;
    }
    .alert-gg .gg-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 1.02rem;
        margin-top: .75rem;
        line-height: 1.02rem;
    }
    .alert-gg .gg-box .input-box{
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #131e30;
    }
    .alert-gg .gg-box .btn{
        width: 1.08rem;
        color: #fff;
        font-size: .56rem;
        font-weight: bold;
        background: #131e30;
        text-align: center;
    }
    .alert-gg .gg-box .input{
        width: 100%;
        height: .8rem;
        color: #fff;
        font-size: .56rem;
        background: #131e30;
        text-align: center;
    }
    .alert-gg .gg-box .dw{
        padding: 0 .3rem;
        color: #a5a5a5;
         font-size: .56rem;
    }

    .alert-gg .progess-box{
        position: relative;
        margin: 1.26rem .3rem 1.2rem 0;
        height: .12rem;
        background: #e8e8e8;
    }
    .alert-gg .progess-box .progess-ul{
        position: absolute;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .alert-gg .progess-box .progess-ul .progess{
        position: relative;
        width: .3rem;
        height: .3rem;
        margin-top: -.18rem;
        background: #e8e8e8;
        border-radius: 50%;
    }
    .alert-gg .progess-box .progess-ul .progess.active{
        width: .48rem;
        height: .48rem;
        margin-top: -.18rem;
        background: #39b4ff;
    }
    .alert-gg .progess-box .progess-ul .progess.active .progess-tips{
        display: block;
    }
    .alert-gg .progess-box .progess-ul .progess-tips{
        display: none;
        position: absolute;
        top: -.84rem;
        width: 1.14rem;
        height: .6rem;
        color: #fff;
        font-size: .36rem;
        line-height: .6rem;
        background: #39b4ff;
        border-radius: .12rem;
        text-align: center;
    }
    .alert-gg .progess-box .progess-ul .progess-tips::after{
        content: '';
        display: block;
        width: 0;
        height: 0;
        margin: -2px 0 0 3px;
        border-left: .18rem solid transparent;
        border-right: .18rem solid transparent;
        border-top: .18rem solid #39b4ff;
        border-bottom: .18rem solid transparent;
    }
    .alert-gg .progess-box .progess-ul .progess-text{
        position: absolute;
        top: .45rem;
    }
    .alert-gg .progess-box .progess-ul .active .progess-text{
        top: .54rem;
    }
    .alert-gg .progess-box .progess-ul .t6{
        left: -.15rem;
    }
    .alert-gg .progess-text .text{
        flex: 1;
    }
    .alert-gg .btn-sure{
        display: block;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/trading.vue